// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nya8","questions":"styles_questions__307Qu","footer":"styles_footer__9mzP8"};